import React, {useCallback} from 'react';
import CircularButton from '../CircularButton';
import PosTabBar from './PosTabBar';
import {POS_FAB_SIZE, usePosLayout} from '../../helpers/posLayout';

/**
 * Wires the phone POS bottom bar into a host navigator (HomeScreen, TablesScreen,
 * OnlineScreen). On phones (Auto layout) it returns a `tabBar` renderer with the order-type
 * button seated in the bar's centre slot; at tablet width it returns
 * `tabBar: undefined` (react-navigation's default bar) and the host keeps its
 * floating {@link CircularButton}.
 *
 * @param {object} navigation Host screen navigation (the order-type switcher navigates between hosts).
 * @param {function(React.ReactNode): React.ReactNode} [wrapFab] Optional wrapper for the button (the guided-tour tooltip).
 * @returns {{isPhone: boolean, tabBar: (function|undefined)}} `isPhone` is the phone-UI flag (false on tablets and on the Classic layout).
 */
export const usePosPhoneTabBar = (navigation, wrapFab) => {
    const {isPhoneUi} = usePosLayout();
    const tabBar = useCallback((props) => {
        const fab = <CircularButton navigation={navigation} iconName="grid" inline showHub size={POS_FAB_SIZE} />;

        return <PosTabBar {...props} centerSlot={wrapFab ? wrapFab(fab) : fab} />;
    }, [navigation, wrapFab]);

    return {isPhone: isPhoneUi, tabBar: isPhoneUi ? tabBar : undefined};
};

export default usePosPhoneTabBar;
